import Config from "Config";
import React from "react";
import { useSelector } from "react-redux";
import { getIamsmartOpenID } from "../../redux/selector";
import { isNotEmpty } from "../../Utils";
import IamsmartLoginedSigningButton from "../IamsmartLoginedSigningButton/IamsmartLoginedSigningButton";
import IamsmartAnonAsLoginedSigningButton from "../IamsmartAnonSigningButton/IamsmartAnonAsLoginedSigningButton";

export default function IamsmartSigningButton({ onSign, hkic, handleSubmit }) {
    const openID = useSelector(getIamsmartOpenID());
    console.log(" IamsmartSigningButton openID=============",openID);
    if (Config.ENABLE_IAMSMART != "true") return <></>;
    else if (isNotEmpty(openID)) {
        return (
            <IamsmartLoginedSigningButton
                onSign={onSign}
                hkic={hkic}
                handleSubmit={handleSubmit}
            />
        );
    } else {
        return (
            <IamsmartAnonAsLoginedSigningButton
                onSign={onSign}
                hkic={hkic}
                handleSubmit={handleSubmit}
            />
        );
    }
}
